module.exports = __webpack_public_path__ + "img/jpm_clock-icon@2x.f9ca6c5b.png";